import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import OfferBanner from "./components/OfferBanner";
import CookieBanner from "./components/CookieBanner";
import MobileStickyBar from "./components/MobileStickyBar";

import Home from "./pages/Home";
import Universita from "./pages/Universita";
import CorsiLaurea from "./pages/CorsiLaurea";
import MasterPage from "./pages/Master";
import DoppiaLaurea from "./pages/DoppiaLaurea";
import Orientamento from "./pages/Orientamento";
import ChiSiamo from "./pages/ChiSiamo";
import Contatti from "./pages/Contatti";
import { Blog, BlogPost } from "./pages/Blog";
import { PrivacyPolicy, CookiePolicy, Gdpr } from "./pages/Legal";
import NotFound from "./pages/NotFound";
import Eventi from "./pages/Eventi";
import { AdminLogin, AdminDashboard } from "./pages/Admin";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

const META = {
  "/": { title: "Polo ECP Profili Sassari | Laurea Online Pegaso, Mercatorum, San Raffaele", desc: "Polo ECP Profili a Sassari: laurea online Pegaso, Mercatorum, San Raffaele. Tutor dedicato, 95 sedi esami, certificazioni EIPASS, rate da 125€/mese." },
  "/universita": { title: "Università telematiche Sassari | Pegaso Mercatorum San Raffaele", desc: "Tre università telematiche riconosciute MIUR in una sola sede a Sassari: Pegaso, Mercatorum, San Raffaele. Iscrizione, esami, tutoraggio." },
  "/corsi-di-laurea": { title: "Corsi di Laurea online Sassari | Triennale, Magistrale, Master", desc: "Tutti i corsi di laurea triennale e magistrale online delle 3 università telematiche al Polo ECP Profili di Sassari." },
  "/master": { title: "Master online a Sassari | Master I° e II° livello con EIPASS", desc: "Master 1° e 2° livello online delle università Pegaso, Mercatorum e San Raffaele. Certificazioni EIPASS incluse." },
  "/doppia-laurea": { title: "Doppia Laurea online Sassari | 2 titoli in meno tempo", desc: "Programma Doppia Laurea: due titoli accademici contemporaneamente con riconoscimento esami. Risparmio tempo e costi." },
  "/orientamento": { title: "Orientamento universitario gratuito Sassari | ECP Profili", desc: "Orientamento gratuito in 48h con un tutor del Polo Profili. Aiuto nella scelta di università e corso." },
  "/chi-siamo": { title: "Chi Siamo | Istituto Europa - Polo ECP Profili Sassari", desc: "Dal 1960 a Sassari: la storia dell'Istituto Europa e del Polo ECP Profili. Scuola paritaria e centro ECP per l'università telematica." },
  "/contatti": { title: "Contatti & Iscrizioni | Polo ECP Profili Sassari", desc: "Contatta il Polo ECP Profili: Via Forlanini 18, Sassari · 079 282 5126 · WhatsApp 346 572 6648 · uni.telematica@istitutoeuropasassari.it" },
  "/blog": { title: "Blog ECP Profili | Guide laurea online e certificazioni", desc: "Guide, articoli e approfondimenti su laurea online, certificazioni EIPASS, doppia laurea e orientamento universitario." },
  "/eventi": { title: "Eventi & Open Day | Polo ECP Profili Sassari", desc: "Open Day, webinar e orientamento individuale presso il Polo ECP Profili di Sassari." },
};

function MetaUpdater() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = META[pathname] || META["/"];
    document.title = meta.title;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", meta.desc);
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", meta.title);
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", meta.desc);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MetaUpdater />
        <OfferBanner />
        <Header />
        <main className="min-h-[60vh]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/universita" element={<Universita />} />
            <Route path="/corsi-di-laurea" element={<CorsiLaurea />} />
            <Route path="/master" element={<MasterPage />} />
            <Route path="/doppia-laurea" element={<DoppiaLaurea />} />
            <Route path="/orientamento" element={<Orientamento />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/gdpr" element={<Gdpr />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/richieste" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <MobileStickyBar />
        <CookieBanner />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
